const t = {
  name: "Breadcrumb",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M16.2878 3.41465L9.58555 21.2873L7.71289 20.5851L14.4151 2.7124L16.2878 3.41465Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as Breadcrumb
};
